import React from 'react';
import { Layout } from 'antd';
import { AppHeader } from './AppHeader';
import { PublicFooter } from './PublicFooter';
import { DevelopmentEnvironmentBanner } from './DevelopmentEnvironmentBanner';

interface PublicHomeLayoutProps {
  children: React.ReactNode;
}

export const PublicHomeLayout: React.FC<PublicHomeLayoutProps> = ({ children }) => {
  return (
    <Layout style={{ minHeight: '100vh', background: '#f7f8fa' }}>
      <AppHeader />
      <Layout.Content style={{ display: 'flex', flexDirection: 'column' }}>
        {children}
        <div style={{ flex: 1 }} />
        <PublicFooter />
        <DevelopmentEnvironmentBanner />
      </Layout.Content>
    </Layout>
  );
};
